if(!customElements.get('variant-picker')) {
  customElements.define('variant-picker', class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.productForm = document.querySelector(`#product_form_${this.productId}`);
      if(!this.productForm) return;
      this.options = this.querySelectorAll('[data-variant]');
      this.rerenderElements = this.productForm.querySelectorAll('[data-should-rerender]');
    }

    get productId() {
      return this.dataset.productId;
    }

    connectedCallback() {
      if(!this.options.length === 0) return;
      this.options.forEach(option => option.addEventListener('click',(event)=> this.handleVariantChange(event, option)));
    }

    handleVariantChange(event, option) {
      event.preventDefault();
      event.stopPropagation();
      const optionGroup = option.closest('.variant-picker__options') || option.closest('[role="group"]');
      const currentValue = optionGroup?.previousElementSibling?.querySelector('[data-current-value]');
      optionGroup?.querySelectorAll('[data-variant]').forEach(el => {
        el.classList.remove('active');
        el.setAttribute('aria-pressed', 'false');
      });
      option.classList.add('active');
      option.setAttribute('aria-pressed', 'true');
      if(currentValue) currentValue.innerText = option.innerText;
      const variantIdInput = this.productForm.querySelector(`#product-select-${this.productId}`) || this.productForm.querySelector('input[type="hidden"][name="id"]');
      if(variantIdInput) variantIdInput.value = option.dataset.variant;
      const url = `${location.origin}${location.pathname}?variant=${option.dataset.variant}`;
      history.replaceState({}, '', url);
      if(this.rerenderElements.length === 0) return;
      this.replaceElements(url);
    }

    async replaceElements(url) {
      const response = await fetch(url);
      const result = await response.text();
      const parser  = new DOMParser().parseFromString(result, 'text/html');
      this.rerenderElements.forEach(el => {
        const valueToRerender = el.dataset.shouldRerender;
        const newEl = parser.querySelector(`[data-should-rerender="${valueToRerender}"]`);
        if(newEl) {
          el.innerHTML = newEl.innerHTML;
        }
      })

    }
  })
}
